const register = {
  loginCredentials: "بيانات اعتماد تسجيل الدخول", // translated
  companyInformation: "معلومات الشركة", // translated
  contactDetails: "بيانات المتصل", // translated
  businessName: "الاسم التجاري", // translated
  businessAddress: "عنوان العمل", // translated
  registrationCode: "رمز التسجيل", // translated
  businessRegistrationNumber: "رقم تسجيل الأعمال", // translated
  websiteUrl: "رابط الموقع", // translated
  mobilePhone: "تليفون محمول", // translated
  regionStateProvince: "المنطقة/الولاية/المقاطعة", // translated
  legalTitle: "العنوان القانوني", // translated
  city: "مدينة", // translated
  postalCode: "رمز بريدي", // translated
  registrationSuccess: "نجاح التسجيل.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "يرجى الانتظار بضع دقائق وسيتم إعادة توجيهك إلى الصفحة الرئيسية.", // translated
  usernameEmail: "اسم المستخدم (البريد الإلكتروني)", // translated
  password: "كلمة المرور", // translated
  verifyPassword: "تأكيد كلمة المرور", // translated
  documents: "المستندات", // translated
  termsAndConditionsSection: "الشروط والأحكام", // translated
  certificateOfIncorporation: "شهادة التأسيس", // translated
  acceptTermsAndConditions: "قبول الشروط والأحكام", // translated
  country: "الدولة", // translated
  brandName: "اسم العلامة التجارية", // translated
  register: "تسجيل", // translated
  isRequired: "مطلوب", // translated
  passwordMin8Chars: "يجب أن يحتوي على 8 أحرف على الأقل", // translated
  passwordRequiresDigit: "يجب أن يحتوي على رقم واحد على الأقل", // translated
  passwordRequiresLowercase: "يجب أن يحتوي على حرف صغير واحد على الأقل", // translated
  passwordRequiresUppercase: "يجب أن يحتوي على حرف كبير واحد على الأقل", // translated
  passwordRequiresSpecialChar: 'يجب أن يحتوي على رمز خاص واحد على الأقل (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "رفع ملف", // translated
  filename: "اسم الملف:", // translated
  fileType: "النوع:", // translated
  fileSize: "الحجم:", // translated
  maxFileSize10Mb: "الحد الأقصى: 10 ميجابايت", // translated
  supportedFileTypes: "أنواع الملفات المدعومة:", // translated
  showPassword: "إظهار كلمة المرور", // translated
  hidePassword: "إخفاء كلمة المرور", // translated
  notAvailable: "غير متاح", // translated
  fileSizeInKb: "{{size}} كيلوبايت", // translated
  mobilePhonePlaceholder: "مثال +966501234567", // translated
  websiteUrlPlaceholder: "http://www.example.com", // translated
  loading: "جاري التحميل...", // translated
  uploadingDocument: "جاري رفع المستند...", // translated
  percentUploaded: "تم رفع {{percent}}%", // translated
  registrationSuccessful: "تم التسجيل بنجاح.", // translated
  failedToUploadDocument: "فشل رفع المستند.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "يجب أن يكون {{field}} أطول من {{min}} أحرف", // translated
  fieldMustBeValidEmail: "يجب أن يكون {{field}} بريدًا إلكترونيًا صالحًا", // translated
  fieldPasswordMinLength: "يجب أن يحتوي {{field}} على 8 أحرف على الأقل", // translated
  fieldPasswordRequiresDigit: "يجب أن يحتوي {{field}} على رقم واحد على الأقل", // translated
  fieldPasswordRequiresLowercase: "يجب أن يحتوي {{field}} على حرف صغير واحد على الأقل", // translated
  fieldPasswordRequiresUppercase: "يجب أن يحتوي {{field}} على حرف كبير واحد على الأقل", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} يجب أن يحتوي على رمز خاص واحد على الأقل (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} لا يطابق {{otherField}}", // translated
  fieldBetweenLength: "يجب أن يكون {{field}} بين {{min}} و {{max}} أحرف", // translated
  postalCodeBetweenLength: "يجب أن يكون {{field}} بين {{min}} و {{max}} أحرف", // translated
  invalidUrlFormat: "تنسيق عنوان غير صالح", // translated
  invalidEmailFormat: "تنسيق بريد إلكتروني غير صالح", // translated
  emailMustMatchUsername: "يجب أن يكون البريد الإلكتروني مطابقًا لاسم المستخدم (البريد الإلكتروني)", // translated
  mobilePhoneIsRequired: "الهاتف المحمول مطلوب", // translated
  certificateFileTooLarge: "ملف شهادة التأسيس كبير جدًا", // translated
  termsMustBeAccepted: "يجب قبول الشروط والأحكام", // translated
};


export default register;
